import React from 'react';
import PropTypes from 'prop-types';

function SendIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <path d='M21.801 10A10 10 0 1 1 17 3.335' />
      <path d='m9 11 3 3L22 4' />
    </svg>
  );
}

SendIcon.propTypes = {
  className: PropTypes.string,
};

export default SendIcon;
